import { useTranslation } from "react-i18next";
import { DeleteOutlined, FilterOutlined } from "@ant-design/icons";
import { Button, Col, DatePicker, Form, Row, Typography } from "antd";
import { FormInstance } from "antd/lib";
import { FunctionComponent } from "react";
import FormItemDropdown from "../../../form-dropdown/FormItemDropdown";
import "./filter-group.scss";

import { FilterData } from "./filter";

type FormFilterProps = {
  handleCloseFilter: () => void;
  showFilter?: boolean;
  form: FormInstance;
  clearFilter: () => void;
  onFinish?: () => void;
  setFilterData: (dateString: string[], planCreationDate: string) => void;
  dataOptions?: any;
  filterData: FilterData;
};

const FormFilter: FunctionComponent<FormFilterProps> = ({
  onFinish,
  form,
  showFilter,
  clearFilter,
  filterData,
  setFilterData,
}) => {
  const { t } = useTranslation();
  const { RangePicker } = DatePicker;

  const dataOptionsFilter = [
    { id: 3, name: t("Chờ quản trị khoá học duyệt", "Chờ quản trị khoá học duyệt") },
    { id: 4, name: t("Quản trị khoá học trả lại", "Quản trị khoá học trả lại") },
    { id: 5, name: t("Chờ hội đồng thẩm định duyệt", "Chờ hội đồng thẩm định duyệt") },
    { id: 12, name: t("Chờ xuất bản", "Chờ xuất bản") },
    { id: 13, name: t("Đã xuất bản", "Đã xuất bản") },
  ];

  const dataOptionsFilterContent = [
    { id: 3, name: t("Chờ quản trị khoá học duyệt", "Chờ quản trị khoá học duyệt") },
    { id: 4, name: t("Quản trị khoá học trả lại", "Quản trị khoá học trả lại") },
    { id: 5, name: t("Chờ hội đồng thẩm định duyệt", "Chờ hội đồng thẩm định duyệt") },
    { id: 6, name: t("Hội đồng thẩm định trả lại", "Hội đồng thẩm định trả lại") },
    { id: 11, name: t("Tổ chuyên môn trả lại", "Tổ chuyên môn trả lại") },
    { id: 12, name: t("Chờ xuất bản", "Chờ xuất bản") },
    { id: 13, name: t("Đã xuất bản", "Đã xuất bản") },
  ];

  const courseType = [
    { id: 1, name: t("Tự triển khai", "Tự triển khai") },
    { id: 2, name: t("Hợp tác xây dựng", "Hợp tác xây dựng") },
    { id: 3, name: t("Dùng chung", "Dùng chung") },
  ];

  return (
    <>
      <div className={`wrapper-filter ${showFilter ? "open" : ""}`}>
        <Form form={form} name="filterForm" onFinish={onFinish}>
          <Row gutter={[{ xs: 8, xl: 24, md: 16 }, 12]}>
            <Col
              xl={{ span: 5 }}
              md={{ span: 5 }}
              sm={{ span: 5 }}
              xs={{ span: 24 }}
            >
              <Typography.Title level={5}>{t("Trạng thái duyệt trang trình bày", "Trạng thái duyệt trang trình bày")}</Typography.Title>
              <Form.Item name="approveSlideStatus">
                <FormItemDropdown
                  placeholder={t("Chọn trạng thái", "Chọn trạng thái")}
                  onChange={(option) => setFilterData(option, "approveSlideStatus")}
                  options={dataOptionsFilter}
                  modeDropdown="multiple"
                />
              </Form.Item>
            </Col>
            <Col
              xl={{ span: 5 }}
              md={{ span: 5 }}
              sm={{ span: 5 }}
              xs={{ span: 24 }}
            >
              <Typography.Title level={5}>{t("Trạng thái duyệt nội dung", "Trạng thái duyệt nội dung")}</Typography.Title>
              <Form.Item name="approveContentStatus">
                <FormItemDropdown
                  placeholder={t("Chọn trạng thái", "Chọn trạng thái")}
                  onChange={(option) => setFilterData(option, "approveContentStatus")}
                  options={dataOptionsFilterContent}
                  modeDropdown="multiple"
                />
              </Form.Item>
            </Col>
            <Col
              xl={{ span: 4 }}
              md={{ span: 5 }}
              sm={{ span: 5 }}
              xs={{ span: 24 }}
            >
              <Typography.Title level={5}>{t("Loại khoá học", "Loại khoá học")}</Typography.Title>
              <Form.Item name="courseType">
                <FormItemDropdown
                  placeholder={t("Chọn trạng thái", "Chọn trạng thái")}
                  onChange={(option) => setFilterData(option, "courseType")}
                  options={courseType}
                  modeDropdown="multiple"
                />
              </Form.Item>
            </Col>
            <Col
              xl={{ span: 4 }}
              md={{ span: 5 }}
              sm={{ span: 5 }}
              xs={{ span: 24 }}
            >
              <Typography.Title level={5}>{t("Ngày duyệt", "Ngày duyệt")}</Typography.Title>
              <Form.Item name="approvedDate">
                <RangePicker
                  placeholder={[t("Từ ngày", "Từ ngày"), t("Đến ngày", "Đến ngày")]}
                  format="DD-MM-YYYY"
                  value={filterData.approvedDate}
                  onChange={(_value, dateString: any) =>
                    setFilterData(dateString, "approvedDate")
                  }
                />
              </Form.Item>
            </Col>
            <Col
              xl={{ span: 3 }}
              md={{ span: 9 }}
              sm={{ span: 9 }}
              xs={{ span: 24 }}
              className="flex align-end"
            >
              <div className="group-btn--filter">
                <Button
                  className="btn btn-primary filter-btn"
                  htmlType="submit"
                  onClick={() => form.submit()}
                >
                  <FilterOutlined />
                  <Typography.Text>{t("Lọc", "Lọc")}</Typography.Text>
                </Button>
                <Button
                  className="btn btn-outlined clear-filter-btn"
                  onClick={clearFilter}
                >
                  <DeleteOutlined />
                  <Typography.Text>{t("Xóa bộ lọc", "Xóa bộ lọc")}</Typography.Text>
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </div>
    </>
  );
};

export default FormFilter;